import React, { FC } from 'react';
import classNames from 'classnames';

import { CheckIcon } from 'components/Icons';

import styles from './Requirement.module.scss';

type RequirementProps = {
  requirement: React.ReactNode;
  valid?: boolean;
  dynamic?: boolean;
  className?: string;
};

const Requirement: FC<RequirementProps> = ({ valid, requirement, dynamic, className }) => {
  const iconContainerStyle = classNames(styles.check_icon_container, {
    [styles.valid]: dynamic && valid,
    [styles.invalid]: dynamic && !valid,
  });

  return (
    <div className={classNames(styles.requirement, className)}>
      <div className={iconContainerStyle}>
        <CheckIcon />
      </div>
      <p className={dynamic ? 'caption' : 'text_small'}>{requirement}</p>
    </div>
  );
};

export default Requirement;
